import { WidgetApi } from "../orchestrator/WidgetApi";
import { getWidgetOrchestrator } from "../orchestrator/orchestrator";
export class WidgetInnerFocus extends WidgetApi {
    async innerFrameTookFocus() {
        getWidgetOrchestrator().then((orchestrator) => {
            orchestrator.widgetInnerFocus(this._widgetInstance);
        });
    }
}
